// extracted by mini-css-extract-plugin
export var contactButton = "styles-module--contactButton--65eaf";
export var container = "styles-module--container--8ea9e";
export var content = "styles-module--content--da7c6";
export var desktop = "1340px";
export var giant = "2200px";
export var largeDesktop = "1600px";
export var largeMobile = "500px";
export var largeTablet = "1025px";
export var logo = "styles-module--logo--be6d4";
export var mobile = "400px";
export var smallDesktop = "1260px";
export var smallMobile = "340px";
export var smallTablet = "660px";
export var socialLink = "styles-module--socialLink--90365";
export var socials = "styles-module--socials--743b0";
export var tablet = "769px";
export var wordmark = "styles-module--wordmark--aaafd";